import { TimelineView } from '@euler/app/tv/components/detail/TimelineView';
import { RightAside } from '@euler/app/tv/components/RightAside';
import { tvModalScreenOptions } from '@euler/app/tv/functions/utils';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';

export const TimelineScreen = wrapNavigatorScreen(() => {
  return (
    <RightAside contentContainerStyle={{ width: '27%' }}>
      <TimelineView />
    </RightAside>
  );
}, tvModalScreenOptions);
